import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { MaintenanceService } from '../../services';

export const serviceUnavailableInterceptor: HttpInterceptorFn = (req, next) => {
    const maintenanceService = inject(MaintenanceService);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 503) {
                maintenanceService.setMaintenanceMode(true);
            }
            return throwError(() => error);
        }),
    );
};
